<!-- #72 -->
<template>
  <v-col class="mx-4">
    <div class="d-flex">
      <div
        class="text-h6 py-0 my-0 pl-0"
        style="color: #23468c; font-weight: 500"
      >
        Inbound Received Expiry Goods
      </div>
      <v-spacer></v-spacer>
    </div>
    <v-divider class="mt-1 mb-4 mr-8"></v-divider>
    <v-data-table
      :headers="headers"
      :items="inboundOrder"
      :options.sync="options"
      :server-items-length="total"
      :loading="inboundOrderLoader"
      class="elevation-1 custom-icon-size mr-8"
      :footer-props="{
        itemsPerPageOptions: [25, 50, 100, 250],
        showFirstLastPage: true,
        firstIcon: 'mdi-arrow-collapse-left',
        lastIcon: 'mdi-arrow-collapse-right',
        prevIcon: 'mdi-minus',
        nextIcon: 'mdi-plus',
      }"
    >
      <template v-slot:top>
        <template>
          <v-form>
            <div class="custom-row">
              <v-col cols="12" sm="3" md="3" class="pb-0">
                <v-autocomplete
                  v-model="warehouse_id"
                  label="Warehouse"
                  item-text="name"
                  item-value="id"
                  :items="warehouses"
                  outlined
                  @change="fetchClientList(warehouse_id)"
                ></v-autocomplete>
              </v-col>
              <v-col
                cols="12"
                sm="3"
                v-if="
                  userCategory.user_category === 3 ||
                  userCategory.user_category === 6
                "
                class="pb-0"
              >
                <v-autocomplete
                  v-model="selectedClient"
                  :items="clients"
                  :loading="clientLoader"
                  hide-no-data
                  item-text="name"
                  item-value="id"
                  label="Select Client"
                  placeholder="Start typing to Search"
                  class="pb-2 pt-0 text-center"
                  @change="getStores()"
                  outlined
                ></v-autocomplete>
              </v-col>

              <v-col cols="12" sm="3" md="3" class="pb-0">
                <v-autocomplete
                  v-model="infor_storer_id"
                  label="Storer Name"
                  item-text="channel_name"
                  item-value="id"
                  :items="stores"
                  outlined
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="3" class="pb-0">
                <v-text-field label="SKU" outlined v-model="sku"></v-text-field>
              </v-col>
              <v-col cols="12" sm="3" class="pb-0">
                <v-text-field
                  label="Receipt key"
                  outlined
                  v-model="receipt_key"
                ></v-text-field>
              </v-col>

              <v-col cols="12" sm="3" class="pb-0">
                <v-text-field
                  label="ASN Type"
                  outlined
                  v-model="asn_type"
                ></v-text-field>
              </v-col>

              <v-col cols="12" sm="3" md="3" class="pb-0">
                <v-autocomplete
                  v-model="status"
                  label="Status"
                  item-text="text"
                  item-value="value"
                  :items="statusArr"
                  outlined
                ></v-autocomplete>
              </v-col>

              <v-col cols="12" sm="3" class="pb-0">
                <v-menu
                  v-model="dateMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      :value="getFormattedDate(from_date)"
                      label="From Date"
                      append-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      clearable
                      outlined
                      @click:clear="clearDateInput('this.from_date')"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="from_date"
                    @input="dateMenu = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" sm="3" class="pb-0">
                <v-menu
                  v-model="dateMenuTo"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      :value="getFormattedDate(to_date)"
                      label="To Date"
                      append-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      clearable
                      outlined
                      @click:clear="clearDateInput('this.to_date')"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="to_date"
                    @input="dateMenuTo = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>

              <v-col
                cols="6"
                class="pr-4"
                :sm="
                  userCategory.user_category == 3 ||
                  userCategory.user_category == 6
                    ? 9
                    : 12
                "
              >
                <v-btn color="white" @click="clearAll" style="float: right"
                  >Clear</v-btn
                >
                <v-btn
                  color="primary"
                  class="success mr-2"
                  @click="searchAll"
                  style="float: right"
                  >Search</v-btn
                >
                <v-btn
                  class="info px-1 mr-2"
                  style="float: right"
                  color="primary"
                  @click="download"
                  v-if="
                    checkPermission(
                      'app_infor:b2b_inbound_received_good_expiry_download'
                    )
                  "
                  >Download</v-btn
                >
                <v-btn
                  color="primary"
                  class="v-btn--is-elevated v-btn--has-bg theme--light v-size--default primary mr-2"
                  @click="sync"
                  :loading="syncButton"
                  style="float: right"
                  v-if="
                    checkPermission(
                      'app_infor:b2b_inbound_received_good_expiry_sync'
                    ) &&
                    warehouse_id &&
                    (userCategory.user_category === 3 ||
                      userCategory.user_category === 6)
                  "
                  >Sync</v-btn
                >
              </v-col>
            </div>
          </v-form>
          <v-divider class="mb-5"></v-divider>
        </template>
      </template>

      <template v-slot:[`item.created_datetime`]="{ item }">
        <span v-if="item.created_datetime"
          >{{
            item.created_datetime
              | localMomentformat
              | moment("DD MMM, YYYY hh:mm A")
          }}<span v-if="item.created_by__name"
            ><br />({{ item.created_by__name }})</span
          ></span
        >
      </template>
      <template v-slot:[`item.receipt_key`]="{ item }">
        <a v-if="checkPermission('app_infor:infor_v1_inbound_list')"
          ><span @click="gotodetailsinbound(item)">{{
            item.receipt_key
          }}</span></a
        ><span v-else>{{ item.receipt_key }}</span>
      </template>
      <template v-slot:[`item.received_datetime`]="{ item }">
        <span v-if="item.received_datetime"
          >{{
            item.received_datetime
              | localMomentformat
              | moment("DD MMM, YYYY hh:mm A")
          }}<br />({{ item.received_by }})</span
        >
      </template>

      <template v-slot:[`item.updated_datetime`]="{ item }">
        <span v-if="item.updated_datetime"
          >{{
            item.updated_datetime
              | localMomentformat
              | moment("DD MMM, YYYY hh:mm A")
          }}<span v-if="item.updated_by__name"
            ><br />({{ item.updated_by__name }})</span
          ></span
        >
      </template>
      <template v-slot:[`item.last_received_datetime`]="{ item }">
        <span v-if="item.last_received_datetime">{{
          item.last_received_datetime
            | localMomentformat
            | moment("DD MMM, YYYY hh:mm A")
        }}</span>
      </template>
      <template v-slot:[`item.last_put_away_datetime`]="{ item }">
        <span v-if="item.last_put_away_datetime">{{
          item.last_put_away_datetime
            | localMomentformat
            | moment("DD MMM, YYYY hh:mm A")
        }}</span>
      </template>
      <template v-slot:[`item.first_received_datetime`]="{ item }">
        <span v-if="item.first_received_datetime">{{
          item.first_received_datetime
            | localMomentformat
            | moment("DD MMM, YYYY hh:mm A")
        }}</span>
      </template>
      <template v-slot:[`item.first_put_away_datetime`]="{ item }">
        <span v-if="item.first_put_away_datetime">{{
          item.first_put_away_datetime
            | localMomentformat
            | moment("DD MMM, YYYY hh:mm A")
        }}</span>
      </template>
      <template v-slot:[`item.cancelled_datetime`]="{ item }">
        <span v-if="item.cancelled_datetime">{{
          item.cancelled_datetime
            | localMomentformat
            | moment("DD MMM, YYYY hh:mm A")
        }}</span>
      </template>
      <template v-slot:[`item.asn_closed_datetime`]="{ item }">
        <span v-if="item.asn_closed_datetime">{{
          item.asn_closed_datetime
            | localMomentformat
            | moment("DD MMM, YYYY hh:mm A")
        }}</span>
      </template>

      <template v-slot:[`item.client_id__name`]="{ item }"
        >{{ item.client_id__name }}<br />
        ({{ item.storer_key }})
      </template>
      <template v-slot:[`item.asn_created_datetime`]="{ item }">
        <span v-if="item.asn_created_datetime">{{
          item.asn_created_datetime
            | localMomentformat
            | moment("DD MMM, YYYY hh:mm A")
        }}</span>
      </template>
      <template v-slot:[`item.status`]="{ item }">
        <v-chip
          :color="
            item.status == 'pending'
              ? 'warning'
              : item.status == 'fixed in wms'
              ? 'green'
              : 'primary'
          "
          :text-color="
            (item.status == item.status) == 'pending' ? 'black' : 'white'
          "
          class="ma-1"
          label
          small
        >
          {{ capitalizeFirstLetter(item.status) }}
        </v-chip>
        <br /><span v-if="item.comments">({{ item.comments }})</span>
      </template>
      <template v-slot:[`item.arrival_datetime`]="{ item }">
        <span v-if="item.arrival_datetime">{{
          item.arrival_datetime
            | localMomentformat
            | moment("DD MMM, YYYY hh:mm A")
        }}</span>
      </template>

      <template v-slot:[`item.putaway_status`]="{ item }">
        {{ item.putaway_status == 1 ? "Completed" : "" }}
      </template>
      <template v-slot:[`item.receipt_key`]="{ item }">
        {{ item.receipt_key }} <br />
        <span v-if="item.external_receipt_key">{{
          item.external_receipt_key
        }}</span>
      </template>

      <template v-slot:[`item.shipping_address_country`]="{ item }">
        <label>
          {{ item.shipping_address_country }}
        </label>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-tooltip
          bottom
          v-if="
            checkPermission(
              'app_infor:b2b_inbound_received_good_expiry_update'
            ) && item.status == 'pending'
          "
        >
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              color="primary"
              v-bind="attrs"
              v-on="on"
              @click="openEditDialog(item)"
            >
              mdi-pencil
            </v-icon>
          </template>
          <span>Edit</span>
        </v-tooltip>
      </template>
    </v-data-table>

    <v-dialog v-model="dialog" max-width="500px">
      <v-card>
        <v-card-title>
          <span
            >{{ this.itemEdit.client_id__name }}-{{ this.itemEdit.sku }}</span
          >
        </v-card-title>
        <v-divider class="mt-1 mb-4"></v-divider>
        <v-card-text class="pb-0 mb-0">
          <v-form ref="form">
            <v-row>
              <v-col cols="12" sm="6" md="6">
                <v-select
                  v-model="statusComment"
                  :items="statusList"
                  label="Status"
                  outlined
                  item-text="text"
                  item-value="value"
                  dense
                  class="required"
                  :rules="[(v) => !!v || 'Status is required.']"
                ></v-select>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field
                  v-model="comments"
                  label="Comment"
                  outlined
                  dense
                  class="required"
                  :rules="[(v) => !!v || 'Comment is required.']"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>

        <v-card-actions class="ml-2">
          <v-btn color="primary" @click="saveData()">Save</v-btn>
          <v-btn
            color="error"
            @click="
              (dialog = false),
                (itemEdit = {}),
                (comments = ''),
                (statusComment = '')
            "
            >Cancel</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-col>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  components: {},
  computed: {
    getEndDate() {
      var endDate = new Date();
      endDate.setDate(endDate.getDate() + 1);
      endDate.setHours(0, 0, 0, 0); // Set hours, minutes, seconds, and milliseconds to zero
      return endDate.toISOString().split("T")[0]; // Keep only the date part
    },
    ...mapGetters(["userRole", "userCategory"]),
    headers() {
      if (this.status == 2) {
        return [
          {
            text: "Client (Storer)",
            value: "client_id__name",
            class: "body-1 font-weight-bold",
            align: "left",
            sortable: false,
            width: 120,
          },
          {
            text: "Warehouse",
            value: "warehouse_id__name",
            class: "body-1 font-weight-bold",
            align: "left",
            sortable: false,
          },

          {
            text: "ASN / Receipt  (External Key)",
            value: "receipt_key",
            class: "body-1 font-weight-bold",
            align: "left",
            sortable: false,
          },

          {
            text: "ASN / Receipt Type",
            value: "asn_type",
            class: "body-1 font-weight-bold",
            align: "left",
            sortable: false,
            width: "150px",
          },
          {
            text: "External Line No",
            value: "external_line_number",
            class: "body-1 font-weight-bold",
            align: "left",
            sortable: false,
          },

          {
            text: "SKU",
            value: "sku",
            class: "body-1 font-weight-bold",
            align: "left",
            sortable: false,
          },
          {
            text: "Description",
            value: "description",
            class: "body-1 font-weight-bold",
            align: "left",
            sortable: false,
          },
          {
            text: "LPN",
            value: "lpn",
            class: "body-1 font-weight-bold",
            align: "left",
            sortable: false,
          },
          {
            text: "Location",
            value: "location",
            class: "body-1 font-weight-bold",
            align: "left",
            sortable: false,
          },
          {
            text: "Received Qty",
            value: "received_qty",
            class: "body-1 font-weight-bold",
            align: "left",
            width: 120,
            sortable: false,
          },
          {
            text: "Mfg Date",
            value: "mfg_date",
            class: "body-1 font-weight-bold",
            align: "left",
            width: 120,
            sortable: false,
          },

          {
            text: "Expiry Date",
            value: "exp_date",
            class: "body-1 font-weight-bold",
            align: "left",
            width: 120,
            sortable: false,
          },
          {
            text: "WMS Received At (By)",
            value: "received_datetime",
            class: "body-1 font-weight-bold",
            align: "left",
            width: 120,
            sortable: false,
          },

          {
            text: "Status (Comments)",
            value: "status",
            class: "body-1 font-weight-bold",
            align: "left",
            sortable: false,
          },
          {
            text: "Created",
            value: "created_datetime",
            class: "body-1 font-weight-bold",
            align: "left",
            width: 120,
            sortable: false,
          },

          {
            text: "Updated (By)",
            value: "updated_datetime",
            class: "body-1 font-weight-bold",
            align: "left",
            width: 120,
            sortable: false,
          },
          {
            text: "Action",
            value: "actions",
            class: "body-1 font-weight-bold",
            align: "left",
            width: 120,
            sortable: false,
          },
        ];
      } else {
        return [
          {
            text: "Client (Storer)",
            value: "client_id__name",
            class: "body-1 font-weight-bold",
            align: "left",
            sortable: false,
            width: 120,
          },
          {
            text: "Warehouse",
            value: "warehouse_id__name",
            class: "body-1 font-weight-bold",
            align: "left",
            sortable: false,
          },

          {
            text: "ASN / Receipt  (External Key)",
            value: "receipt_key",
            class: "body-1 font-weight-bold",
            align: "left",
            sortable: false,
          },

          {
            text: "ASN / Receipt Type",
            value: "asn_type",
            class: "body-1 font-weight-bold",
            align: "left",
            sortable: false,
            width: "150px",
          },
          {
            text: "External Line No",
            value: "external_line_number",
            class: "body-1 font-weight-bold",
            align: "left",
            sortable: false,
          },

          {
            text: "SKU",
            value: "sku",
            class: "body-1 font-weight-bold",
            align: "left",
            sortable: false,
          },
          {
            text: "Description",
            value: "description",
            class: "body-1 font-weight-bold",
            align: "left",
            sortable: false,
          },
          {
            text: "LPN",
            value: "lpn",
            class: "body-1 font-weight-bold",
            align: "left",
            sortable: false,
          },
          {
            text: "Location",
            value: "location",
            class: "body-1 font-weight-bold",
            align: "left",
            sortable: false,
          },
          {
            text: "Received Qty",
            value: "received_qty",
            class: "body-1 font-weight-bold",
            align: "left",
            width: 120,
            sortable: false,
          },
          {
            text: "Mfg Date",
            value: "mfg_date",
            class: "body-1 font-weight-bold",
            align: "left",
            width: 120,
            sortable: false,
          },

          {
            text: "Expiry Date",
            value: "exp_date",
            class: "body-1 font-weight-bold",
            align: "left",
            width: 120,
            sortable: false,
          },
          {
            text: "WMS Received At (By)",
            value: "received_datetime",
            class: "body-1 font-weight-bold",
            align: "left",
            width: 120,
            sortable: false,
          },

          {
            text: "Status (Comments)",
            value: "status",
            class: "body-1 font-weight-bold",
            align: "left",
            sortable: false,
          },
          {
            text: "Created",
            value: "created_datetime",
            class: "body-1 font-weight-bold",
            align: "left",
            width: 120,
            sortable: false,
          },

          {
            text: "Updated",
            value: "updated_datetime",
            class: "body-1 font-weight-bold",
            align: "left",
            width: 120,
            sortable: false,
          },
          {
            text: "Action",
            value: "actions",
            class: "body-1 font-weight-bold",
            align: "left",
            width: 120,
            sortable: false,
          },
        ];
      }
    },
  },
  data: () => ({
    syncButton: false,
    infor_storer_id: null,
    to_date: null,
    from_date: null,
    dateMenu: false,
    dateMenuTo: false,
    receipt_key: null,
    receipt_no: null,
    orderDetails: [],
    statuses: [],
    status: 0,

    inboundOrder: [],
    options: {},
    total: 0,
    warehouse_id: null,

    clients: [],
    selectedClient: null,
    filtersArr: {},
    stores: [],
    warehouses: [],
    storer_key: "",
    inboundOrderLoader: false,
    sku: null,
    statusArr: [
      { text: "Pending", value: 0 },
      { text: "Fixed in WMS", value: 1 },
      { text: "Actual Expired Date", value: 2 },
    ],
    statusList: [{ text: "Actual Expired Date", value: 2 }],
    dialog: false,
    itemEdit: {},
    statusComment: "",
    asn_type: null,
  }),

  watch: {
    options: {
      handler() {
        this.getlist();
      },
      deep: true,
    },
  },
  created() {
    this.getwarehouse();
    if (this.$store.getters.user.user_category == 1) {
      this.selectedClient = this.$store.getters.user.id;
    }
  },

  methods: {
    ...mapActions([
      "snackBar",
      "getInboundGooodsSummary",
      "fetchClient",
      "getChannelDropdown",
      "getWarehouseStores",
      "getInforWarehouseList",
      "inboundGoodsSync",
      "addGoodsComment",
      "downloadInboundGoods",
    ]),
    download() {
      this.allFilters();

      this.downloadInboundGoods({ ...this.filtersArr })
        .then((res) => {
          this.fileDownload(res);
        })
        .catch(() => {});
    },
    getwarehouse() {
      this.storer_key = "";
      this.sku = null;
      this.warehouse_id = null;

      this.getInforWarehouseList().then((response) => {
        this.warehouses = response.data.result;
      });
    },
    openEditDialog(item) {
      this.itemEdit = item;
      this.dialog = true;
    },
    gotodetailsinbound(item) {
      window.open(
        this.$router.resolve({
          name: "InboundList",
          query: {
            key: item.receipt_key,
            id: item.client_id_id,
          },
        }).href,
        "_blank"
      );
    },
    getStores() {
      this.infor_storer_id = null;
      this.sku = null;
      let payload = {
        client_id: this.selectedClient,
        warehouse_id: this.warehouse_id,
      };
      if (this.selectedClient && this.warehouse_id) {
        this.getWarehouseStores(payload).then((res) => {
          this.stores = res.data;
        });
      } else {
        this.stores = [];
      }
    },

    clearDateInput(type) {
      if (type == "this.to_date") {
        this.to_date = "";
      } else {
        this.from_date = "";
      }
    },
    allFilters() {
      this.orderLoader = true;
      let obj = {
        client_id: this.selectedClient,
        receipt_key: this.receipt_key
          ? this.receipt_key.trim()
          : this.receipt_key,
        start_date: this.from_date,
        end_date: this.to_date,
        storer_id: this.infor_storer_id,
        warehouse: this.warehouse_id,
        storer_key: this.storer_key,
        sku: this.sku ? this.sku.trim() : this.sku,
        status: this.status,
        asn_type: this.asn_type,
      };
      Object.keys(obj).forEach((key) => {
        if (obj[key] === null || obj[key] === undefined || obj[key] === "") {
          delete obj[key];
        }
      });
      this.filtersArr = obj;
    },

    clearAll() {
      this.receipt_key = "";
      this.receipt_no = "";
      this.status = "";
      this.from_date = null;
      this.to_date = null;
      this.storer_key = "";
      this.sku = null;
      this.asn_type = null;
      this.infor_storer_id = null;
      this.selectedClient = null;
      this.warehouse_id = null;
      this.clients = [];
      this.stores = [];
      this.searchAll();
    },

    fetchClientList() {
      this.clients = [];
      this.stores = [];

      if (
        this.userCategory.user_category === 3 ||
        this.userCategory.user_category === 6
      ) {
        this.clientLoader = true;

        this.fetchClient({
          fields: "id,name",
          pagination: 0,
          service: "b2b_fulfillment",
          active_facility: 1,
          type: "warehouse",
          warehouse_id: this.warehouse_id,
        })
          .then((res) => {
            this.clientLoader = false;
            this.clients = res.data;
          })
          .catch(() => {
            this.clientLoader = false;
          });
      }
    },
    getlist() {
      this.allFilters();

      this.getInboundGooodsSummary({
        ...this.options,
        ...this.filtersArr,
      })
        .then((res) => {
          this.inboundOrderLoader = false;
          this.inboundOrder = res.data.records;
          this.tableDetailsItems = res.data.records2;
          this.client_variant_sku = res.data.client_variant_sku;
          this.total = res.data.total;
        })
        .catch(() => {
          this.inboundOrderLoader = false;
        });
    },
    sync() {
      this.syncButton = true;
      let index = this.warehouses.findIndex(
        (item) => item.id == this.warehouse_id
      );

      let payload = {
        warehouse: this.warehouses[index].name,
      };
      this.inboundGoodsSync(payload)
        .then((response) => {
          this.syncButton = false;

          this.snackBar({
            color: "success",
            message: response.data.message,
          });
          this.getlist();
        })
        .catch(() => {
          this.syncButton = false;
        });
    },
    findSummary(id) {
      this.inboundorderSummary(id).then((res) => {
        this.orderDetails = res.data.data.items;
        this.summary = true;
      });
    },
    tracking(id) {
      this.orderTracking(id).then((res) => {
        this.trackingDetails = res.data.data.records;
        this.reverseData = res.data.data.event_history;
        this.trackingPage = true;
      });
    },
    saveData() {
      if (!this.$refs.form.validate()) {
        return;
      }
      let data = {
        comments: this.comments,
        status: this.statusComment,
      };
      let payload = {
        id: this.itemEdit.id,
        data: data,
      };
      this.addGoodsComment(payload)
        .then((res) => {
          this.comments = "";
          this.statusComment = "";
          this.dialog = false;
          this.getlist();
          this.snackBar({
            color: "success",
            message: res.data.message,
          });
        })
        .catch(() => {
          this.comments = "";
          this.statusComment = "";
          this.dialog = false;
        });
      this.itemEdit = {};
    },
    searchAll() {
      this.options.page = 1;
      this.allFilters();
      this.getInboundGooodsSummary({
        ...this.options,
        ...this.filtersArr,
      })
        .then((res) => {
          this.inboundOrderLoader = false;
          this.inboundOrder = res.data.records;
          this.tableDetailsItems = res.data.records2;
          this.client_variant_sku = res.data.client_variant_sku;

          this.total = res.data.total;
        })
        .catch(() => {
          this.inboundOrderLoader = false;
        });
    },
    gotodetails(item) {
      window.open(
        this.$router.resolve({
          name: "InboundSummary",
          query: {
            key: item.id,
            id: item.client_id,
          },
        }).href,
        "_blank"
      );
    },
  },
};
</script>
<style scoped>
.custom-row {
  display: flex !important;
  flex-wrap: wrap !important;
  padding: 5px 3px 5px 5px !important;
}
</style>
